var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cpage-meta state=\"{{ vm.loanRequest.purpose }}\" document=\"Loan request #{{ vm.loanRequest.reference }}: {{ vm.loanRequest.purpose }}\"\u003E\u003C\u002Fpage-meta\u003E\u003Cdiv class=\"md-padding\"\u003E\u003Chelp-box class=\"loan-details\" ng-if=\"vm.loanRequest.status === 'fulfilled'\" heading=\"Loan details: {{ vm.loanRequest.reference }}\"\u003E\u003Cp\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E Warning: the information on this page was current at {{ vm.loanRequest.auction.endDate | date }}. \nBorrowers' circumstances may vary over the period of a loan.\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Ch2 class=\"loan-details\" ng-if=\"vm.loanRequest.status != 'fulfilled'\"\u003ELoan details: {{ vm.loanRequest.reference }}\u003C\u002Fh2\u003E\u003Cdiv layout=\"row\" layout-xs=\"column\"\u003E\u003Cdiv class=\"characteristics\" flex\u003E\u003Cdot-point class=\"key-info amount\" layout=\"row\" flex asset-name=\"icon-2019-total-loan\" label=\"Total loan\"\u003E\u003Cvalue\u003E{{ vm.loanRequest.amount | asCurrency:0 }}\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003Cdot-point class=\"key-info term\" layout=\"row\" flex asset-name=\"icon-2019-term\" label=\"{{ vm.loanRequest.loanId ? &quot;Original term&quot; : &quot;Term&quot; }}\"\u003E\u003Cvalue\u003E{{ vm.loanRequest.termInMonths | asTerm }}\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003Cdot-point class=\"key-info residual\" layout=\"row\" flex asset-name=\"icon-2019-balloon\" label=\"Balloon\"\u003E\u003Cvalue\u003E{{ vm.loanRequest.residual | asCurrency:0 }}\u003Chelp-mate topic=\"keyinfo-balloon\"\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003Cdot-point class=\"key-info loan-purpose\" ng-if=\"vm.isOriginatedFromTruePillars\" layout=\"row\" flex asset-name=\"icon-2019-loan-purpose\" label=\"Loan purpose\"\u003E\u003Cvalue\u003E{{ vm.loanRequest.purpose }}\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003Cdot-point class=\"key-info portfolio\" ng-if=\"!vm.isOriginatedFromTruePillars\" layout=\"row\" flex asset-name=\"icon-2019-loan-origination\" label=\"Loan origin\"\u003E\u003Cvalue\u003EPortfolio purchase\u003Chelp-mate topic=\"keyinfo-origination\"\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"ratings\" flex\u003E\u003Cdot-point class=\"key-info risk-rating\" layout=\"row\" flex asset-name=\"icon-2019-risk-rating\" label=\"{{ vm.loanRequest.loanId ? &quot;Original rating&quot; : &quot;Risk rating&quot; }}\"\u003E\u003Cvalue class=\"risk\"\u003E{{ vm.loanRequest.riskRating | asRiskRating }}\u003Chelp-mate topic=\"keyinfo-risk-rating\"\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003Cdot-point class=\"key-info security-grade\" layout=\"row\" flex asset-name=\"icon-2019-security-grade\" label=\"{{ vm.loanRequest.loanId ? &quot;Original security category&quot; : &quot;Security category&quot; }}\"\u003E\u003Cvalue class=\"security\"\u003E{{ vm.loanRequest.securityRating }}\u003Chelp-mate topic=\"keyinfo-security-grade\"\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003Cdot-point class=\"key-info security\" layout=\" row\" flex asset-name=\"icon-2019-security\" label=\"Security\"\u003E\u003Cvalue data-ng-bind-html=\"vm.loanRequest.security | fromMarkdown\"\u003E\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ch2 class=\"borrower-details\"\u003EBorrower details\u003C\u002Fh2\u003E\u003Cdiv layout=\"row\" layout-xs=\"column\"\u003E\u003Cdiv class=\"demographics\" flex\u003E\u003Cdot-point class=\"key-info sector\" layout=\"row\" flex asset-name=\"icon-2019-industry\" label=\"Industry\"\u003E\u003Cvalue\u003E{{ vm.loanRequest.borrowerDetails.sector }}\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003Cdot-point class=\"key-info region\" layout=\"row\" flex asset-name=\"icon-2019-region\" label=\"Region\"\u003E\u003Cvalue\u003E{{ vm.loanRequest.borrowerDetails.region }}\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"borrower-info\" flex\u003E\u003Cdot-point class=\"key-info category\" layout=\"row\" flex asset-name=\"icon-2019-business-type\" label=\"Business type\"\u003E\u003Cvalue\u003E{{ vm.loanRequest.borrowerDetails.category }}\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003Cdot-point class=\"key-info trading-since\" ng-if=\"!vm.loanRequest.borrowerDetails.tradingNotes\" layout=\"row\" flex asset-name=\"icon-2019-trading-since\" label=\"Trading since\"\u003E\u003Cvalue\u003E{{ vm.loanRequest.borrowerDetails.tradingSince | date: 'yyyy' }}\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003Cdot-point class=\"key-info trading-notes\" ng-if=\"vm.loanRequest.borrowerDetails.tradingNotes\" layout=\"row\" flex asset-name=\"icon-2019-trading-since\" label=\"Trading since\"\u003E\u003Cvalue ng-bind-html=\"vm.loanRequest.borrowerDetails.tradingNotes\"\u003E\u003C\u002Fvalue\u003E\u003C\u002Fdot-point\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"additional-comments fine\" ng-if=\"vm.loanRequest.additionalComments\"\u003E\u003Cp data-ng-bind-html=\"vm.loanRequest.additionalComments | fromMarkdown\"\u003E\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;